import { ResolverHttpClient } from '../../definition/httpClient';
import type { NoParams, Resolver } from '../../definition/resolver';
import type { RejectUndefinedData } from '../../../resources/types';
import { attachPromise } from './attachPromise';

export const fromHttpPromise = <TData, TParams = NoParams>(
  name: string,
  fetch: (httpClient: ResolverHttpClient, params: TParams) => Promise<TData>
): RejectUndefinedData<TData, Resolver<TParams, TData>> =>
  ({
    name,
    tags: ['http', 'promise'],
    attach: (params, runtime) =>
      attachPromise(
        () => fetch(runtime.env.httpClient, params),
        params,
        runtime,
        'http'
      ),
  }) as RejectUndefinedData<TData, Resolver<TParams, TData>>;
